import { LANGUAGE_FILTER_ALL } from '@/shared/config';

import { TRANSCRIPTOR_LANGUAGE } from '../config';

import { normalizeContentLanguage } from './normalizeContentLanguage';

type ResolveDefaultContentLanguageArgs = {
  locale: string;
  availableLanguages: string[];
};

export const resolveDefaultContentLanguage = ({
  locale,
  availableLanguages,
}: ResolveDefaultContentLanguageArgs): string => {
  const base = normalizeContentLanguage(locale);

  if (availableLanguages.length === 0 || availableLanguages.includes(base)) {
    return base;
  }

  if (availableLanguages.includes(TRANSCRIPTOR_LANGUAGE.English)) {
    return TRANSCRIPTOR_LANGUAGE.English;
  }

  return LANGUAGE_FILTER_ALL;
};
